import api from "./client";

/**
 * Fetch a PDF from an authenticated API endpoint and open it in a new tab.
 *
 * Uses the axios instance (which attaches Bearer + X-API-Key headers) with
 * responseType "blob", then creates an object URL for the browser to display.
 *
 * @param {string} apiPath  — The API path (e.g. "/invoices/INV-00001/pdf").
 *                            Must NOT include the base URL; the axios instance
 *                            prepends it automatically.
 * @param {"GET"|"POST"} [method="GET"] — HTTP method.
 * @param {*} [body]       — Request body (only used for POST).
 * @returns {Promise<void>}
 */
export async function openAuthenticatedPdf(apiPath, { method = "GET", body } = {}) {
  const res =
    method === "POST"
      ? await api.post(apiPath, body, { responseType: "blob" })
      : await api.get(apiPath, { responseType: "blob" });

  const url = URL.createObjectURL(res.data);
  const opened = window.open(url, "_blank");
  if (!opened) {
    // Popup may have been blocked — fall back to a hidden link click
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

/** Fetch a file from an authenticated API endpoint and download it as `filename`. */
export async function downloadAuthenticatedFile(apiPath, filename) {
  const res = await api.get(apiPath, { responseType: "blob" });
  const cd = res.headers?.["content-disposition"] || "";
  const m = cd.match(/filename="?([^";]+)"?/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = (m && m[1]) || filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
